<!--
 * @Author: mazhigang
 * @Date: 2023-07-01 19:16:24
 * @LastEditors: mazhigang
 * @LastEditTime: 2024-03-03 18:38:21
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>用户详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageTab">
        <div style="text-align: right; margin-bottom: 10px">
          <el-button type="primary" @click="edit()" v-if="pageStatus == 0"
            >编辑</el-button
          >
          <div v-else>
            <el-button @click="pageStatus = 0">取消</el-button>
            <el-button type="primary" @click="edit()">保存</el-button>
          </div>
        </div>
        <div class="solidBox">
          <div class="modelTitle">
            {{ detail.accountType == 0 ? "企业" : "个人" }}信息
          </div>
          <div
            class="modelDetail"
            v-if="detail.accountType == 0"
            style="display: flex; justify-content: space-between"
          >
            <div style="display: flex; flex-wrap: wrap; width: 75%">
              <div class="infoItem">
                公司名称：{{ detail.companyInfo.companyName }}
              </div>
              <div class="infoItem">手机号：{{ detail.companyInfo.phone }}</div>
              <div class="infoItem">
                创建时间：{{ detail.companyInfo.gmtCreate }}
              </div>
              <div class="infoItem" v-if="pageStatus == 0">
                是否保安公司：{{ detail.isSecurityCompany == 0 ? "否" : "是" }}
              </div>
              <div class="infoItem" v-if="pageStatus == 0">
                统一社会信用代码：{{
                  detail.companyInfo ? detail.companyInfo.licenseNo : ""
                }}
              </div>
              <div class="infoItem" v-if="pageStatus == 0">
                注册住址：{{
                  detail.companyInfo ? detail.companyInfo.address : ""
                }}
              </div>
              <div class="infoItem" v-if="pageStatus == 0">
                注册资金：{{ detail.companyInfo.registeredCapital }}万
              </div>
              <div class="infoItem" v-if="pageStatus == 0">
                经营范围：{{ detail.companyInfo.gscScope }}
              </div>
            </div>
            <el-image
              v-if="detail.accountType == 0 && pageStatus == 0"
              style="width: 150px; height: 100px"
              :src="detail.businessLicense"
              alt=""
              :preview-src-list="[detail.businessLicense]"
            ></el-image>
          </div>
          <div
            style="display: flex; justify-content: space-between"
            v-if="detail.accountType == 1"
          >
            <div class="modelDetail">
              <div class="infoItem">姓名：{{ detail.name }}</div>
              <div class="infoItem">民族：{{ detail.nationality }}</div>
              <div class="infoItem">手机号：{{ detail.phone }}</div>
              <div class="infoItem">创建时间：{{ detail.gmtCreate }}</div>
              <div class="infoItem">支付宝账号：{{ detail.alipayCode }}</div>
              <div class="infoItem">微信号：{{ detail.wechatCode }}</div>
              <div class="infoItem" v-if="pageStatus == 0">
                身份证号：{{ detail.cardCode }}
              </div>
              <div class="infoItem" v-if="pageStatus == 0">
                出生日期：{{ detail.birthday }}
              </div>
              <div class="infoItem" v-if="pageStatus == 0">
                家庭住址：{{ detail.address }}
              </div>
            </div>
            <el-image
              style="width: 300px; height: 200px; margin-left: 20px"
              :src="detail.cardFrontUrl"
              alt=""
              :preview-src-list="[detail.cardFrontUrl]"
            ></el-image>
            <el-image
              style="width: 300px; height: 200px; margin-left: 20px"
              :src="detail.cardBackUrl"
              alt=""
              :preview-src-list="[detail.cardBackUrl]"
            ></el-image>
          </div>
        </div>
        <div class="solidBox" v-if="detail.accountType == 0 && pageStatus == 0">
          <div class="modelTitle">保安服务许可证信息</div>
          <div
            class="modelDetail"
            style="display: flex; justify-content: space-between"
          >
            <div style="display: flex; flex-wrap: wrap; width: 75%">
              <div class="infoItem">
                许可证编号：{{ detail.companyInfo.serviceLicenseNumber }}
              </div>
              <div class="infoItem">
                服务范围：{{ detail.companyInfo.gscScope }}
              </div>
            </div>
            <el-image
              style="width: 150px; height: 100px"
              :src="detail.companyInfo.guardLicenseUrl"
              alt=""
              :preview-src-list="detail.companyInfo.guardLicenseUrl"
            ></el-image>
          </div>
        </div>
        <div class="solidBox" v-if="detail.accountType == 0 && pageStatus == 0">
          <div class="modelTitle">法人信息</div>
          <div
            class="modelDetail"
            style="display: flex; justify-content: space-between"
          >
            <div style="display: flex; flex-wrap: wrap; width: 65%">
              <div class="infoItem">
                姓名：{{ detail.legalPersonResp.name }}
              </div>
              <div class="infoItem">
                性别：{{ detail.legalPersonResp.sex == 1 ? "男" : "女" }}
              </div>

              <div class="infoItem">
                出生年月：{{ detail.legalPersonResp.birthday }}
              </div>
              <div class="infoItem">
                证件有效期：{{ detail.legalPersonResp.cardValidityStart }}-{{
                  detail.legalPersonResp.cardValidityEnd
                }}
              </div>
              <div class="infoItem">
                签发机关：{{ detail.legalPersonResp.issuingAuthority }}
              </div>
              <div class="infoItem">
                地址：{{ detail.legalPersonResp.currentAddress }}
              </div>
            </div>
            <div>
              <el-image
                style="width: 150px; height: 100px"
                :src="detail.legalPersonResp.cardPhotoFront"
                alt=""
                :preview-src-list="[detail.legalPersonResp.cardPhotoFront]"
              ></el-image>
              <el-image
                style="width: 150px; height: 100px"
                :src="detail.legalPersonResp.cardPhotoBack"
                alt=""
                :preview-src-list="[detail.legalPersonResp.cardPhotoBack]"
              ></el-image>
            </div>
          </div>
        </div>
        <div v-if="pageStatus == 1" style="margin-top: 20px">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <div v-if="detail.accountType == 0">
              <el-form-item label="营业执照号" prop="num">
                <el-input v-model="ruleForm.num"></el-input>
              </el-form-item>
              <el-form-item label="注册地址" prop="address">
                <el-input v-model="ruleForm.address"></el-input>
              </el-form-item>
              <el-form-item label="法人姓名" prop="name">
                <el-input v-model="ruleForm.name"></el-input>
              </el-form-item>
              <el-form-item label="社会统一信用代码" prop="num1">
                <el-input v-model="ruleForm.num1"></el-input>
              </el-form-item>
              <el-form-item
                label="是否保安公司"
                prop="company"
                label-width="130"
                style="display: flex; align-items: center"
              >
                <el-radio-group v-model="ruleForm.company">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="营业执照照片" prop="img">
                <div style="position: relative">
                  <el-upload
                    class="avatar-uploader"
                    :action="uploadUrl"
                    :headers="deader"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                  >
                    <img
                      v-if="ruleForm.img"
                      :src="ruleForm.img"
                      class="avatar"
                      style="width: 100px"
                    />
                    <div class="modelView1" v-if="ruleForm.img">编辑</div>
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </div>
              </el-form-item>
            </div>
            <div v-if="detail.accountType == 1">
              <el-form-item label="身份证号码" prop="idNum">
                <el-input v-model="ruleForm.idNum"></el-input>
              </el-form-item>
              <el-form-item label="性别" prop="sex">
                <el-select v-model="ruleForm.sex" placeholder="请选择">
                  <el-option label="未知" value="0"> </el-option>
                  <el-option label="男" value="1"> </el-option>
                  <el-option label="女" value="2"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="出生年月" prop="year">
                <el-input v-model="ruleForm.year"></el-input>
              </el-form-item>
              <el-form-item label="家庭住址" prop="address1">
                <el-input v-model="ruleForm.address1"></el-input>
              </el-form-item>
              <el-form-item label="身份证照片（正面）" prop="img1">
                <div style="position: relative">
                  <el-upload
                    class="avatar-uploader"
                    :action="uploadUrl"
                    :headers="deader"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess1"
                  >
                    <img
                      v-if="ruleForm.img1"
                      :src="ruleForm.img1"
                      class="avatar"
                      style="width: 300px; height: 200px; margin-left: 20px"
                    />
                    <div class="modelView" v-if="ruleForm.img1">编辑</div>
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </div>
              </el-form-item>
              <el-form-item label="身份证照片（反面）" prop="img2">
                <div style="position: relative">
                  <el-upload
                    class="avatar-uploader"
                    :action="uploadUrl"
                    :headers="deader"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess2"
                  >
                    <img
                      v-if="ruleForm.img2"
                      :src="ruleForm.img2"
                      class="avatar"
                      style="width: 300px; height: 200px; margin-left: 20px"
                    />
                    <div class="modelView" v-if="ruleForm.img2">编辑</div>
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </div>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="modelTitle" style="margin-top: 30px">账号信息</div>
        <div class="modelDetail">
          <div class="infoItem">等级：{{ detail.accountLevel }}</div>
          <div class="infoItem">等级积分：{{ detail.levelExperience }}分</div>
          <div class="infoItem">充值金额：￥{{ detail.rechargeAmount }}</div>
          <div class="infoItem">余额：￥{{ detail.balanceAmount }}</div>
          <div class="infoItem">违约金额：￥{{ detail.defaultAmount }}</div>
          <div class="infoItem">违约次数：{{ detail.failedJobs }}</div>
          <div class="infoItem">任务次数：{{ detail.jobsTotal }}</div>
          <!-- <div class="infoItem">红包金额：￥{{ detail.redPacketAmount }}</div> -->
          <div class="infoItem">
            手机品牌：{{
              detail.lastPhoneBrand ? detail.lastPhoneBrand : "null"
            }}
          </div>
          <div class="infoItem">
            手机型号：{{
              detail.lastPhoneModel ? detail.lastPhoneModel : "null"
            }}
          </div>
          <div class="infoItem">
            手机系统号：{{
              detail.lastPhoneSystemVersion
                ? detail.lastPhoneSystemVersion
                : "null"
            }}
          </div>
          <div class="infoItem">
            最近登录地址：{{
              detail.lastLoginAddress ? detail.lastLoginAddress : ""
            }}
          </div>
          <div class="infoItem">
            最近登录省份：{{
              detail.lastLoginProvince ? detail.lastLoginProvince : ""
            }}
          </div>
          <div class="infoItem">
            最近登录城市：{{ detail.lastLoginCity ? detail.lastLoginCity : "" }}
          </div>
          <div class="infoItem">
            最近登录地区：{{ detail.lastLoginArea ? detail.lastLoginArea : "" }}
          </div>
          <div class="infoItem">
            最近登录时间：{{ detail.lastLoginTime ? detail.lastLoginTime : "" }}
          </div>
          <div class="infoItem">
            当前App版本号：{{ detail.versionNo ? detail.versionNo : "null" }}
          </div>
        </div>
        <div
          class="solidBox"
          v-if="
            detail.accountType != 0 &&
            detail.xwbankStatus == 1 &&
            detail.memberBanksVO
          "
          style="margin-top: 20px"
        >
          <div class="modelTitle">个人开户信息</div>
          <div class="modelDetail" style="display: flex">
            <div>
              <div class="infoItem">姓名：{{ detail.cardName }}</div>
              <div class="infoItem">地址：{{ detail.address }}</div>
              <div class="infoItem">身份证号：{{ detail.cardCode }}</div>
              <div class="infoItem">
                银行卡号：{{ detail.memberBanksVO.bankAccountNo }}
              </div>
              <div class="infoItem">
                开户行名称：{{ detail.memberBanksVO.bankFullName }}
              </div>
              <div class="infoItem">手机号码：{{ detail.phone }}</div>
              <div class="infoItem">
                职业：{{ detail.individualVocationName }}
              </div>
            </div>
            <div style="margin-left: 50px">
              <div style="margin-bottom: 20px">身份证照片</div>
              <el-image
                style="width: 150px; height: 100px"
                :src="detail.cardFrontUrl"
                alt=""
                :preview-src-list="[detail.cardFrontUrl]"
              ></el-image>
              <el-image
                style="width: 150px; height: 100px"
                :src="detail.cardBackUrl"
                alt=""
                :preview-src-list="[detail.cardBackUrl]"
              ></el-image>
            </div>
          </div>
        </div>

        <div
          class="solidBox"
          v-if="
            detail.accountType == 0 &&
            detail.xwbankStatus == 1 &&
            detail.companyInfo
          "
          style="margin-top: 20px"
        >
          <div class="modelTitle">企业开户信息</div>
          <div
            class="modelDetail"
            style="display: flex; justify-content: space-between"
          >
            <div style="width: 30%">
              <div>
                <div style="margin: 20px 0">营业执照照片</div>
                <el-image
                  style="width: 150px; height: 100px"
                  :src="detail.companyInfo.businessLicense"
                  alt=""
                  :preview-src-list="[detail.companyInfo.businessLicense]"
                ></el-image>
              </div>
              <div class="infoItem">
                企业全称：{{ detail.companyInfo.companyName }}
              </div>
              <div class="infoItem">
                经营证件类型：{{ detail.companyInfo.enterpriseLicenseName }}
              </div>
              <div class="infoItem">
                营业执照号码：{{ detail.companyInfo.licenseNo }}
              </div>
              <div class="infoItem">
                行业代码：{{ detail.companyInfo.enterpriseTrade }}
              </div>
              <div class="infoItem">
                企业实际经营地址：{{ detail.companyInfo.enterpriseRealAddress }}
              </div>
              <div class="infoItem">
                企业对公户开户行名称：{{ detail.companyInfo.bankName }}
              </div>
              <div class="infoItem">
                企业对公户开户行号：{{ detail.companyInfo.bankAccountNo }}
              </div>
              <div class="infoItem">
                企业对公账户号：{{ detail.companyInfo.enterpriseBankCardNo }}
              </div>
            </div>
            <div style="width: 30%">
              <div>
                <div style="margin: 20px 0">法人身份证照片</div>
                <el-image
                  style="width: 150px; height: 100px"
                  :src="
                    JSON.parse(detail.companyInfo.legalPerson).cardPhotoFront
                  "
                  alt=""
                  :preview-src-list="[
                    JSON.parse(detail.companyInfo.legalPerson).cardPhotoFront,
                  ]"
                ></el-image>
                <el-image
                  style="width: 150px; height: 100px"
                  :src="
                    JSON.parse(detail.companyInfo.legalPerson).cardPhotoBack
                  "
                  alt=""
                  :preview-src-list="[
                    JSON.parse(detail.companyInfo.legalPerson).cardPhotoBack,
                  ]"
                ></el-image>
              </div>
              <div class="infoItem">
                法人姓名：{{ JSON.parse(detail.companyInfo.legalPerson).name }}
              </div>
              <div class="infoItem">法人证件类型：身份证</div>
              <div class="infoItem">
                法人身份证号：{{
                  JSON.parse(detail.companyInfo.legalPerson).cardNo
                }}
              </div>
              <div class="infoItem">
                法人手机号：{{
                  JSON.parse(detail.companyInfo.legalPerson).contactInformation
                }}
              </div>
              <div class="infoItem">
                企业控股股东名称：{{
                  JSON.parse(detail.companyInfo.enterpriseShareholderInfo)[0]
                    .enterpriseShareholderName
                }}
              </div>
              <div class="infoItem">企业控股股东证件类型：身份证</div>
              <div class="infoItem">
                企业控股股东证件号码：{{
                  JSON.parse(detail.companyInfo.enterpriseShareholderInfo)[0]
                    .enterpriseShareholderIdCardNo
                }}
              </div>
              <div class="infoItem">
                企业控股股东证件起始日期：{{
                  JSON.parse(detail.companyInfo.enterpriseShareholderInfo)[0]
                    .enterpriseShareholderIdCardValidStartDate
                }}
              </div>
              <div class="infoItem">
                企业控投股东证件截止日期：{{
                  JSON.parse(detail.companyInfo.enterpriseShareholderInfo)[0]
                    .enterpriseShareholderIdCardValidDate
                }}
              </div>
            </div>
            <div style="width: 30%">
              <div>
                <div style="margin: 20px 0">联系人身份证照片</div>
                <el-image
                  style="width: 150px; height: 100px"
                  :src="
                    JSON.parse(detail.companyInfo.contactInfo).cardPhotoFront
                  "
                  alt=""
                  :preview-src-list="[
                    JSON.parse(detail.companyInfo.contactInfo).cardPhotoFront,
                  ]"
                ></el-image>
                <el-image
                  style="width: 150px; height: 100px"
                  :src="
                    JSON.parse(detail.companyInfo.contactInfo).cardPhotoBack
                  "
                  alt=""
                  :preview-src-list="[
                    JSON.parse(detail.companyInfo.contactInfo).cardPhotoBack,
                  ]"
                ></el-image>
              </div>
              <div class="infoItem">
                联系人姓名：{{
                  JSON.parse(detail.companyInfo.contactInfo).name
                }}
              </div>
              <div class="infoItem">联系人证件类型：身份证</div>
              <div class="infoItem">
                联系人身份证号：{{
                  JSON.parse(detail.companyInfo.contactInfo).cardNo
                }}
              </div>
              <div class="infoItem">
                联系人手机号：{{
                  JSON.parse(detail.companyInfo.contactInfo).contactInformation
                }}
              </div>
              <div class="infoItem">
                企业最终受益人名称：{{
                  JSON.parse(detail.companyInfo.enterpriseBeneficiaryInfos)[0]
                    .enterpriseBeneficiaryName
                }}
              </div>
              <div class="infoItem">
                企业最终受益人证件类型：{{
                  JSON.parse(detail.companyInfo.enterpriseBeneficiaryInfos)[0]
                    .enterpriseBeneficiaryIdCardType == "B01"
                    ? "身份证"
                    : JSON.parse(
                        detail.companyInfo.enterpriseBeneficiaryInfos
                      )[0].enterpriseBeneficiaryIdCardType == "B04"
                    ? "护照"
                    : "营业执照"
                }}
              </div>
              <div class="infoItem">
                企业最终受益人证件号码：{{
                  JSON.parse(detail.companyInfo.enterpriseBeneficiaryInfos)[0]
                    .enterpriseBeneficiaryIdCardNo
                }}
              </div>
              <div class="infoItem">
                企业最终受益人联系电话：{{
                  JSON.parse(detail.companyInfo.enterpriseBeneficiaryInfos)[0]
                    .enterpriseBeneficiaryIdContactPhone
                }}
              </div>
              <div class="infoItem">
                企业最终受益人证件起始日期：{{
                  JSON.parse(detail.companyInfo.enterpriseBeneficiaryInfos)[0]
                    .enterpriseBeneficiaryIdCardValidStartDate
                }}
              </div>
              <div class="infoItem">
                企业最终受益人证件截止日期：{{
                  JSON.parse(detail.companyInfo.enterpriseBeneficiaryInfos)[0]
                    .enterpriseBeneficiaryIdCardValidDate
                }}
              </div>
              <div class="infoItem">
                企业最终受益人联系地址：{{
                  JSON.parse(detail.companyInfo.enterpriseBeneficiaryInfos)[0]
                    .enterpriseBeneficiaryAddress
                }}
              </div>
              <div class="infoItem">
                企业最终受益人受益方式：{{
                  JSON.parse(detail.companyInfo.enterpriseBeneficiaryInfos)[0]
                    .enterpriseBeneficiaryShareRatio == "A01"
                    ? "直接或间接控股25%（含）以上"
                    : JSON.parse(
                        detail.companyInfo.enterpriseBeneficiaryInfos
                      )[0].enterpriseBeneficiaryShareRatio == "A02"
                    ? "通过人事、财务等其他方式对公司进行控制"
                    : JSON.parse(
                        detail.companyInfo.enterpriseBeneficiaryInfos
                      )[0].enterpriseBeneficiaryShareRatio == "A03"
                    ? "高级管理人员"
                    : JSON.parse(
                        detail.companyInfo.enterpriseBeneficiaryInfos
                      )[0].enterpriseBeneficiaryShareRatio == "A04"
                    ? "法人或公司负责人"
                    : "其他"
                }}
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="modelTitle" style="margin-top: 30px;">用户标签</div>
        <div class="modelDetail" style="margin-top: 20px;">
          <div
            v-for="(item, index) in detail.tagsList"
            :key="index"
            class="item all"
          >
            {{ item.name }}
          </div>
          <el-button type="primary" @click="addTag()"
            >添加<i class="el-icon-plus"></i
          ></el-button>
        </div> -->
        <div class="modelTitle" style="margin-top: 30px">记录列表</div>
        <div style="margin-top: 30px">
          <el-tabs type="border-card" @tab-click="handleClick">
            <el-tab-pane label="任务记录"
              ><el-table
                ref="scrollTable"
                :data="tableData"
                border
                style="width: 100%"
              >
                <el-table-column prop="jobNo" label="任务编号" align="center">
                </el-table-column>
                <el-table-column prop="title" label="任务名称" align="center">
                </el-table-column>
                <el-table-column label="任务类型" align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.type == 1"> 普通任务 </span>
                  </template>
                </el-table-column>
                <el-table-column label="要求身高" align="center">
                  <template slot-scope="scope">
                    <span>{{
                      scope.row.high == 0 ? "不限" : scope.row.high
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="membersNum"
                  label="要求人数"
                  align="center"
                >
                </el-table-column>
                <!-- <el-table-column label="单价" align="center">
                  <template slot-scope="scope">
                    <span>￥{{ scope.row.unitPrice }}</span>
                  </template>
                </el-table-column> -->
                <el-table-column label="保安单价" align="center">
                  <template slot-scope="scope">
                    <span>￥{{ scope.row.unitPrice }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="用户单价" align="center">
                  <template slot-scope="scope">
                    <span>￥{{ scope.row.customUnitPrice }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="总计" align="center">
                  <template slot-scope="scope">
                    <span>￥{{ scope.row.price }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="状态" align="center">
                  <template slot-scope="scope">
                    <span class="redColor" v-if="scope.row.status == 0"
                      >待支付</span
                    >
                    <span class="blueColor" v-if="scope.row.status == 1"
                      >待发布</span
                    >
                    <span class="blueColor" v-if="scope.row.status == 2"
                      >发布中</span
                    >
                    <span class="blueColor" v-if="scope.row.status == 3"
                      >已收单</span
                    >
                    <span class="blueColor" v-if="scope.row.status == 4"
                      >实做中</span
                    >
                    <span class="greenColor" v-if="scope.row.status == 5"
                      >已取消</span
                    >
                    <span class="greenColor" v-if="scope.row.status == 6"
                      >已结算</span
                    >
                  </template>
                </el-table-column>
                <el-table-column label="创建/完成时间" align="center">
                  <template slot-scope="scope">
                    <div>{{ scope.row.actionAt }}</div>
                    <div>{{ scope.row.jobEnd }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                  <template slot-scope="scope">
                    <div
                      @click="selectInfo(scope.row.id)"
                      style="cursor: pointer; color: blue"
                    >
                      查看任务
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <!-- <el-tab-pane label="充值记录"
              ><el-table ref="scrollTable":data="tableData" border style="width: 100%">
                <el-table-column prop="id" label="编号" align="center">
                </el-table-column>
                <el-table-column
                  prop="creditAmount"
                  label="充值金额"
                  align="center"
                >
                </el-table-column>
                <el-table-column prop="" label="充值类型" align="center">
                </el-table-column>
                <el-table-column label="状态" align="center">
                  <template slot-scope="scope">
                    <span>{{
                      scope.row.status == 0 ? "未确认" : "已确认"
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="payAt" label="交易时间" align="center">
                </el-table-column>
              </el-table>
            </el-tab-pane> -->
            <el-tab-pane label="违约记录"
              ><el-table
                ref="scrollTable"
                :data="tableData"
                border
                style="width: 100%"
              >
                <el-table-column prop="violateLogNo" label="编号" width="180">
                </el-table-column>
                <el-table-column prop="jobTitle" label="任务名称" width="180">
                </el-table-column>
                <el-table-column prop="violateRuleId" label="触发规则">
                </el-table-column>
                <el-table-column prop="violateAmount" label="违约金额">
                </el-table-column>
                <el-table-column prop="violateAt" label="违约时间">
                </el-table-column> </el-table
            ></el-tab-pane>
            <el-tab-pane label="登录记录"
              ><el-table
                ref="scrollTable"
                :data="tableData"
                border
                style="width: 100%"
              >
                <el-table-column prop="id" label="编号" width="180">
                </el-table-column>
                <el-table-column prop="ip" label="ip" width="180">
                </el-table-column>
                <el-table-column prop="address" label="所在地">
                </el-table-column>
                <el-table-column prop="gmtCreate" label="登录时间">
                </el-table-column> </el-table
            ></el-tab-pane>
            <el-tab-pane label="钱包明细">
              <el-button
                type="primary"
                @click="exportList()"
                class="btn"
                style="margin-bottom: 10px"
                >导出</el-button
              >
              <el-table
                ref="scrollTable"
                :data="tableData"
                border
                style="width: 100%"
              >
                <el-table-column
                  prop="billDetailNo"
                  label="帐单编号"
                  width="130"
                >
                </el-table-column>
                <el-table-column prop="jobNo" label="任务编号" width="130">
                </el-table-column>
                <el-table-column prop="jobName" label="任务名称" width="130">
                </el-table-column>
                <!-- <el-table-column prop="channelType" label="支付方式">
                  <template slot-scope="scope">
                    <span v-if="scope.row.channelType == 0">钱包</span>
                    <span v-if="scope.row.channelType == 1">对公转账</span>
                    <span v-if="scope.row.channelType == 2">银行卡</span>
                    <span v-if="scope.row.channelType == 3">支付宝</span>
                    <span v-if="scope.row.channelType == 4">微信</span>
                  </template>
                </el-table-column> -->
                <el-table-column label="变动类型" width="130">
                  <template slot-scope="scope">
                    <span>{{ scope.row.changeName }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="changeAmount" label="变动金额">
                  <template slot-scope="scope">
                    {{ scope.row.changeTo == 0 ? "+" : "-"
                    }}{{
                      scope.row.changeType == 3
                        ? scope.row.changeAmount
                        : scope.row.actualAmount
                    }}
                  </template>
                </el-table-column>
                <el-table-column prop="channelName" label="支付方式">
                </el-table-column>
                <el-table-column
                  prop="thirdPaymentOrder"
                  label="第三方流水号"
                  width="130"
                >
                </el-table-column>
                <el-table-column
                  prop="paymentOrder"
                  label="平台支付单号"
                  width="130"
                >
                </el-table-column>
                <el-table-column prop="changeAmount" label="支付状态">
                  <template slot-scope="scope">
                    <span>{{ scope.row.statusName }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="paymentAt" label="支付时间" width="130">
                </el-table-column>
                <el-table-column prop="gmtCreate" label="创建时间" width="130">
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="pageSize"
              layout="total, prev, pager, next,sizes"
              :total="total"
            >
            </el-pagination>
          </el-tabs>
        </div>
      </div>
    </div>
    <el-dialog
      title="用户标签"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div class="tagList">
        <div
          v-for="(item, index) in tagsList"
          :key="index"
          :class="['item', item.isSelect == '1' ? 'select' : '']"
          @click="selectTag(item)"
        >
          {{ item.name }}
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="confrimTag()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import system from "../../components/system_left.vue";
import axiosUrl from "../../api/axios.js";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.userData(),
      editId: "",
      tableData: [],
      age: 0,
      year: 0,
      detail: {},
      pageSize: 10,
      page: 1,
      total: 0,
      selectIndex: 0, //记录列表选中的下标
      pageStatus: 0,
      ruleForm: {
        address: "",
        name: "",
        num: "",
        num1: "",
        img: "",
        idNum: "",
        sex: "",
        year: "",
        address1: "",
        img2: "",
        company: "",
      },
      deader: {
        "x-ba-admin-token": localStorage.getItem("TOKEN"),
      },
      rules: {
        num: [{ required: true, message: "必填项", trigger: "blur" }],
        idNum: [{ required: true, message: "必填项", trigger: "blur" }],
        sex: [{ required: true, message: "必选项", trigger: "change" }],
        company: [{ required: true, message: "必选项", trigger: "change" }],
        year: [{ required: true, message: "必填项", trigger: "blur" }],
        address1: [{ required: true, message: "必填项", trigger: "blur" }],
        img1: [{ required: true, message: "必填项", trigger: "blur" }],
        img2: [{ required: true, message: "必填项", trigger: "blur" }],
      },
      dialogVisible: false,
      tagsList: [],
      srcList: [],
      srcList1: [],
      srcList2: [],
      uploadUrl: "",
    };
  },
  mounted() {
    if (this.$route.query.id) {
      this.editId = this.$route.query.id;
      this.getDetail1();
      this.getlist();
    }
    this.year = new Date().getFullYear();
    this.uploadUrl = axiosUrl.defaults.baseURL + "admapi/sys/file/upload";
  },
  methods: {
    exportList() {
      this.$confirm("是否导出数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(
              "/admapi/custom/billdetailexport",
              { userId: this.editId },
              {
                responseType: "blob",
              }
            )
            .then((data) => {
              console.log(data);
              let val = new Blob([data.data], {
                type: "application/vnd.ms-excel;charset=utf-8",
              });
              let header = decodeURI(data.headers["content-disposition"]);
              console.log(header);
              let index = header.indexOf("''");
              let fileName = header.substring(index + 2, header.length);
              const url = window.URL.createObjectURL(val);
              const link = document.createElement("a");
              link.download = fileName; // 设置a标签的下载属性
              link.style.display = "none";
              link.href = url;
              document.body.appendChild(link);
              link.click();
              URL.revokeObjectURL(link.href); // 下载完成释放URL 对象
              document.body.removeChild(link);
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
    selectInfo(val) {
      this.$router.push({
        path: "/taskDetail",
        query: {
          id: val,
        },
      });
    },
    handleAvatarSuccess(res, file) {
      this.ruleForm.img = res.data;
    },
    handleAvatarSuccess1(res, file) {
      this.ruleForm.img1 = res.data;
    },
    handleAvatarSuccess2(res, file) {
      this.ruleForm.img2 = res.data;
    },
    edit() {
      if (this.pageStatus == 0) {
        this.pageStatus = 1;
      } else {
        if (this.detail.accountType == 0) {
          if (this.ruleForm.num == "") {
            this.$message({
              message: "请填写必填项",
              type: "warning",
            });
            return;
          } else {
            let param = {
              licenseNo: this.ruleForm.num,
              companyAddress: this.ruleForm.address,
              corporateName: this.ruleForm.name,
              taxNo: this.ruleForm.num1,
              businessLicense: this.ruleForm.img,
              id: this.editId,
              isSecurityCompany: this.ruleForm.company,
            };
            this.$axios
              .post(`/admapi/custom/update`, param)
              .then(({ data }) => {
                this.$message({
                  message: "编辑成功",
                  type: "success",
                });
                this.getDetail1();
                this.pageStatus = 0;
              })
              .catch()
              .finally();
          }
        } else {
          if (
            this.ruleForm.idNum == "" ||
            this.ruleForm.sex == "" ||
            this.ruleForm.year == "" ||
            this.ruleForm.address1 == "" ||
            this.ruleForm.img1 == "" ||
            this.ruleForm.img2 == ""
          ) {
            this.$message({
              message: "请填写必填项",
              type: "warning",
            });
            return;
          } else {
            let param = {
              cardCode: this.ruleForm.idNum,
              sex: this.ruleForm.sex,
              birthday: this.ruleForm.year,
              address: this.ruleForm.address1,
              cardFrontUrl: this.ruleForm.img1,
              cardBackUrl: this.ruleForm.img2,
              id: this.editId,
            };
            this.$axios
              .post(`/admapi/custom/update`, param)
              .then(({ data }) => {
                this.$message({
                  message: "编辑成功",
                  type: "success",
                });
                this.getDetail1();
                this.pageStatus = 0;
              })
              .catch()
              .finally();
          }
        }
      }
    },
    getDetail1() {
      this.$axios
        .post(`/admapi/custom/get/${this.editId}`)
        .then(({ data }) => {
          this.detail = data;
          this.srcList = [data.cardFrontUrl];
          this.srcList1 = [data.cardBackUrl];
          this.srcList2 = [data.businessLicense];
          this.ruleForm.num = data.companyInfo
            ? data.companyInfo.licenseNo
            : "";
          this.ruleForm.address = data.companyInfo
            ? data.companyInfo.address
            : "";
          this.ruleForm.name = data.legalPersonResp
            ? data.legalPersonResp.name
            : "";
          this.ruleForm.num1 = data.companyInfo
            ? data.companyInfo.licenseNo
            : "";
          this.ruleForm.img = data.companyInfo
            ? data.companyInfo.businessLicense
            : "";
          this.ruleForm.idNum = data.cardCode;
          this.ruleForm.year = data.birthday;
          this.ruleForm.address1 = data.address;
          this.ruleForm.img1 = data.cardFrontUrl;
          this.ruleForm.img2 = data.cardBackUrl;
          this.ruleForm.company = data.isSecurityCompany;
          this.ruleForm.sex = data.sex.toString();
        })
        .catch()
        .finally();
    },
    handleSizeChange(val) {
      console.log(val);
      this.pageSize = val;
      this.getlist();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getlist();
    },
    getlist() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        customId: this.editId,
      };
      let url = "";
      if (this.selectIndex == 0) {
        //任务记录
        url = "/admapi/custom/joblist";
      } else if (this.selectIndex == 1) {
        //违约记录
        url = "/admapi/custom/violationlist";
      } else if (this.selectIndex == 2) {
        //登录记录
        url = "/admapi/custom/loginlist";
      } else if (this.selectIndex == 3) {
        //钱包明细
        url = "/admapi/custom/billdetaillist";
      } else {
        //充值记录
        url = "/admapi/custom/rechargelist";
      }
      this.$axios
        .post(url, param)
        .then(({ data }) => {
          this.tableData = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
    handleClick(tab) {
      this.selectIndex = tab.index;
      this.pageSize = 10;
      this.page = 1;
      this.getlist();
    },
    addTag() {
      this.getTag();
    },
    handleClose() {
      this.dialogVisible = false;
    },
    confrimTag() {
      let arr = [];
      for (var i = 0; i < this.tagsList.length; i++) {
        if (this.tagsList[i].isSelect == "1") {
          arr.push(this.tagsList[i].id);
        }
      }
      let param = {
        id: this.editId,
        tagIdList: arr,
      };
      this.$axios
        .post(`/admapi/custom/updatetag/${this.editId}`, param)
        .then(({ data }) => {
          this.$message({
            message: "编辑成功",
            type: "success",
          });
          this.dialogVisible = false;
          this.getDetail1();
        })
        .catch()
        .finally();
    },
    getTag() {
      let param = {
        page: 1,
        pageSize: 10000,
      };
      this.$axios
        .post("/admapi/tag/availabllist", param)
        .then(({ data }) => {
          let arr = data.items;
          let arr1 = this.detail.tagsList;
          if (arr1.length > 0) {
            for (var i = 0; i < arr.length; i++) {
              for (var v = 0; v < arr1.length; v++) {
                if (arr1[v].id == arr[i].id) {
                  arr[v].isSelect = "1";
                } else {
                  arr[v].isSelect = "0";
                }
              }
            }
          } else {
            for (var v = 0; v < arr.length; v++) {
              arr[v].isSelect = "0";
            }
          }
          this.tagsList = arr;
          this.dialogVisible = true;
        })
        .catch()
        .finally();
    },
    selectTag(val) {
      for (var i = 0; i < this.tagsList.length; i++) {
        if (val.isSelect == "1") {
          this.tagsList[i].isSelect = "0";
        } else {
          this.tagsList[i].isSelect = "1";
        }
      }
    },
  },
};
</script>
<style scoped>
.solidBox {
  /* border: solid 1px #e8e8e8; */
  padding: 10px 10px;
  box-sizing: border-box;
  margin-bottom: 10px;
}
.modelView {
  position: absolute;
  top: 0;
  left: 20px;
  width: 300px;
  height: 200px;
  background: rgb(0, 0, 0, 0.4);
  text-align: center;
  line-height: 200px;
  color: #fff;
}
.modelView1 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100px;
  height: 135px;
  background: rgb(0, 0, 0, 0.4);
  text-align: center;
  line-height: 135px;
  color: #fff;
}
.modelTitle {
  border-left: solid 5px #165dff;
  padding-left: 20px;
  box-sizing: border-box;
  font-size: 22px;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
}
.modelDetail {
  display: flex;
  flex-wrap: wrap;
  padding-left: 20px;
  box-sizing: border-box;
}
.infoItem {
  margin-right: 80px;
  color: #6d6b6b;
  margin-top: 24px;
  display: flex;
  align-items: center;
}
.infoItem img {
  width: 300px;
  height: 200px;
  margin-left: 20px;
}
.tagList {
  display: flex;
  flex-wrap: wrap;
}
.item {
  padding: 4px 10px;
  box-sizing: border-box;
  border: solid #6d6b6b 1px;
  text-align: center;
  line-height: 30px;
  border-radius: 8px;
  margin-right: 20px;
  cursor: pointer;
}
.all {
  color: #165dff;
  border-color: #165dff;
}
.select {
  border: none;
  background: #165dff;
  color: #fff;
}
</style>
